export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT2 = 'YYYY-MM-DD-HH:mm';
